import React from 'react'
import { Sentry } from '@helpers'
import {
  AwarenessContextProvider,
  ChuckClientProvider,
  initChuckClient,
  ProfileContextProvider,
  UserContextProvider
} from '@gopeerproject/chuck'
import { SocketContextProvider } from '@contexts'

const chuckClient = initChuckClient({
  formatUrl: (url) => {
    if (
      process.env.STAGE === 'local' &&
      process.env.LYCEUM_URL &&
      (url.includes('/classrooms/') ||
        url.includes('/recordings/') ||
        url.includes('/classroom_groups/'))
    ) {
      return `${process.env.LYCEUM_URL}${url}`
    }
    return ('/api' + url).replace('/api', process.env.API_URL)
  },
  captureException: (err) => Sentry.track(err),
  Storage: localStorage
})

export const ChuckContextProvider = ({ children }) => {
  return (
    <ChuckClientProvider client={chuckClient}>
      <UserContextProvider>
        <ProfileContextProvider>
          <AwarenessContextProvider>
            <SocketContextProvider>{children}</SocketContextProvider>
          </AwarenessContextProvider>
        </ProfileContextProvider>
      </UserContextProvider>
    </ChuckClientProvider>
  )
}
